export const CELL_CHECKBOX_RENDERER_CLASS_NAME = 'CellCheckboxRenderer';
